import { actions } from '@app/store/action/layout';
import { PANEL_SIZE } from '@constant/layout';

export default function (state = {}, action) {
  const { type } = action;
  switch (type) {
    case actions.HIDE_UI: {
      return {
        ...state,
        hidden: true,
      };
    }

    case actions.SHOW_UI:
      return {
        ...state,
        hidden: false,
      };
    case actions.SET_WALLPAPER_UI_STYLE:
      return {
        ...state,
        wallpaper: {
          ...state.wallpaper,
          ...action.styles,
        },
      };
    case actions.RESET_WALLPAPER_UI_STYLE:
      return {
        ...state,
        wallpaper: {
          uploadSpinnerTransitionColor:
            state.wallpaper.uploadSpinnerTransitionColor,
        },
      };
    case actions.SET_PANEL_SIZE_FULL:
      return {
        ...state,
        panel: {
          ...state.panel,
          size: PANEL_SIZE.FULL,
        },
      };
    case actions.SET_PANEL_SIZE_HALF:
      return {
        ...state,
        panel: {
          ...state.panel,
          size: PANEL_SIZE.HALF,
        },
      };

    case actions.SET_PANEL_SIZE_NONE:
      return {
        ...state,
        panel: {
          ...state.panel,
          size: PANEL_SIZE.NONE,
        },
      };
  }

  return state;
}
